var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaxum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1920px",
    height: "684px",
    viewBox: "0 0 1920 684",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Extra Large Copy 5@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large-Copy-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(55, 94)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6429271,244 C76.6429271,150.392727 154.715926,74.5309091 251,74.5309091 L251,0 C112.39473,0 0,109.223273 0,244 L76.6429271,244 Z",
    id: "Path",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.426577,489.368638 L275.426577,382.127923 L309.439788,382.127923 C368.66279,382.127923 421.883461,358.430536 421.883461,292.559835 C421.883461,227.492435 373.0645,205 311.04041,205 L207,205 L207,489.368638 L275.426577,489.368638 Z M304.237767,327.503439 L275.426577,327.503439 L275.426577,260.427785 L305.438234,260.427785 C329.847714,260.427785 353.456884,265.649243 353.456884,292.961486 C353.456884,319.872077 329.847714,327.503439 304.237767,327.503439 M523.167245,489.368638 L543.975327,433.539202 L653.617912,433.539202 L675.626461,489.368638 L751.655991,489.368638 L634.010297,205 L567.584497,205 L448.738336,489.368638 L523.167245,489.368638 Z M634.810608,378.513067 L563.582942,378.513067 L599.59693,280.911967 L634.810608,378.513067 Z M868.945991,489.368638 L928.569149,388.955983 L990.593239,489.368638 L1075.02603,489.368638 L972.586245,339.151307 L1062.22106,205 L982.590131,205 L930.569926,293.363136 L877.74941,205 L795.317393,205 L886.55283,339.151307 L787.314285,489.368638 L868.945991,489.368638 Z M1263.5437,497 C1337.57245,497 1385.5911,450.408528 1385.5911,382.127923 L1385.5911,205 L1317.16452,205 L1317.16452,376.504814 C1317.16452,407.030261 1302.75893,435.145805 1263.94385,435.145805 C1225.52893,435.145805 1210.72318,407.030261 1210.72318,376.504814 L1210.72318,205 L1142.69676,205 L1142.69676,382.127923 C1142.69676,450.408528 1189.11479,497 1263.5437,497 M1549.69929,489.368638 L1548.09867,288.141678 L1549.29913,288.141678 L1620.92695,489.368638 L1668.9456,489.368638 L1742.5742,288.141678 L1743.77467,288.141678 L1742.17404,489.368638 L1809,489.368638 L1809,205 L1710.16161,205 L1648.53768,387.349381 L1646.93705,387.349381 L1582.51203,205 L1485.27426,205 L1485.27426,489.368638 L1549.69929,489.368638 Z",
    id: "Shape",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxum);
export default __webpack_public_path__ + "static/media/paxum.670574c01e485bbcf55c128042136d76.svg";
export { ForwardRef as ReactComponent };